import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { TranslateLoader } from '@cfp/core';
// eslint-disable-next-line import/no-restricted-paths -- Consider moving PortfolioPdfDownloadButtonComponent to features-shared
import { PortfolioPdfDownloadButton } from '@cfp/domains/portfolio/pdf-download-button';
import { TranslateModule } from '@ngx-translate/core';
import { catchError, map, of, switchMap } from 'rxjs';

@Component({
  selector: 'cfp-report-buildings-download-button',
  templateUrl: 'report-buildings-download-button.html',
  imports: [PortfolioPdfDownloadButton, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportBuildingsDownloadButton {
  public readonly portfolioId = input.required<number>();
  public readonly fileName = input.required<string>();
  public readonly buttonOutline = input<boolean>(true);
  /** Optional report path segment after /report/:portfolioId/ (default: buildings) */
  public readonly reportPath = input<string>('buildings');
  /** Optional i18n module to preload (default: portfolio-buildings-roadmap-report) */
  public readonly translationModule = input<string>('portfolio-buildings-roadmap-report');
  /** Optional translate key for the button label */
  public readonly downloadLabelKey = input<string>('portfolioBuildingsRoadmapReport.download');
  public readonly dataAnalytics = input<string>('portfolioBuildingsRoadmapReportDownload');

  private readonly translateLoader = inject(TranslateLoader);

  protected readonly isTranslationLoaded = toSignal(
    toObservable(this.translationModule).pipe(
      switchMap((translationModule) =>
        this.translateLoader.loadTranslation(translationModule).pipe(
          map(() => true),
          catchError(() => of(false))
        )
      )
    ),
    { initialValue: false }
  );

  protected readonly url = computed(() => `/report/${this.portfolioId()}/${this.reportPath()}`);
}
